import styled from 'styled-components';
import {
  colors,
  size,
  typography,
  TertiaryLink,
  mediaQueries,
} from '@everlywell/leaves';
import { GatsbyImage } from 'gatsby-plugin-image';

export const ImageCard = styled.div`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  width: 550px;
  max-width: 800px;
  margin-bottom: ${size.lg}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl4}px;
    flex-direction: row;
    width: 800px;
  }
`;

export const Heading = styled.h2`
  ${typography.h4Text};
  text-align: left;
  margin-bottom: ${size.sm}px;
`;

export const Content = styled.p`
  ${typography.bodyTextSmall};
  font-weight: ${typography.weight.light};
  text-align: left;

  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.bodyText};
    line-height: 29px;
    letter-spacing: 0.5px;
  }
`;

export const CTA = styled(TertiaryLink)`
  margin-top: ${size.xs1}px;
`;

export const Image = styled(GatsbyImage)`
  width: 100%;
  height: 207px;

  ${mediaQueries.forTabletVerticalUp} {
    height: 259px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    width: 259px;
    min-width: 259px;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${size.lg}px ${size.lg}px;

  ${mediaQueries.forTabletHorizontalUp} {
    justify-content: center;
    padding: 0 ${size.md}px 0 ${size.xl3}px;
  }
`;

export const Type = styled.span`
  ${typography.overlineText}
  text-align: left;
  color: ${colors.teal4};
  font-weight: ${typography.weight.bold};
  margin-bottom: 12px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.lg}px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;
